export default {
  namespaced: true,
  state() {
    return {
      isChange: false,
      idcardFace: [], // 身份证正面
      idcardEmblem: [] // 身份证正面
    }
  },
  mutations: {
    setIsChange(state, val) {
      state.isChange = val
    },
    setIdcardFace(state,val){
      state.idcardFace = val
    },
    setIdcardEmblem(state,val){
      state.idcardEmblem = val

    },
  },
  getters: {},
  actions: {}
}
